import facilitiesApi from './api';

export * from './api';
export default facilitiesApi;
